import { Link } from 'react-router-dom';

import { cx } from '../lib/class-names';

import styles from './PortalComponents.module.css';

export function StatCard({
  label,
  value,
  linkTo,
  linkLabel = 'View details',
  hint,
  icon,
  className,
}: {
  label: string;
  value: string | number;
  linkTo?: string;
  linkLabel?: string;
  hint?: string;
  icon?: React.ReactNode;
  className?: string;
}): React.JSX.Element {
  const content = (
    <>
      {icon !== undefined && <span className={styles.statIcon}>{icon}</span>}
      <p className={styles.statLabel}>{label}</p>
      <p className={styles.statValue}>{value}</p>
      {hint !== undefined && hint !== '' && <p className={styles.statHint}>{hint}</p>}
      {linkTo !== undefined && <p className={styles.statLinkHint}>{linkLabel}</p>}
    </>
  );

  if (linkTo === undefined) {
    return <article className={cx(styles.statCard, className)}>{content}</article>;
  }

  return (
    <Link className={cx(styles.statCard, styles.statCardInteractive, className)} to={linkTo}>
      {content}
    </Link>
  );
}
